module.exports = __webpack_public_path__ + "img/icons8-image (1) 1.4f46fbff.svg";